import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import banner1 from "../assets/banner1.jpeg";
import banner2 from "../assets/banner2.jpeg";
import banner3 from '../assets/SanjeevKumar.jpg';
import Box from "@mui/material/Box";

const sliderItems = [
  {
    id: 1,
    image: banner1,
    url: "https://www.quickdials.in/",
  },
  {
    id: 2,
    image: banner2,
    url: "https://www.quickdials.in/",
  },
  {
    id: 3,
    image: banner3,
    url: "https://www.quickdials.in/category/Sanjeev%20Kumar%20Full%20Stack%20Developer%20/68884f6eaf35a1f4591d0725",
  },
];

const Header = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };
  return (
    <div>
      {/* Slider Section */}
      <Box
        className="slider-container"
        style={{
          width: "100%",
          height: {
            xs: "200px",
            sm: "200px",
            md: "400px",
            lg: "500px",
          },
          overflow: "hidden",
    position: "relative",
    zIndex: 1, // 👈 important
        }}
      >
        <Slider {...settings}>
          {sliderItems?.map((item) => (
            <Box
              key={item.id}
              component="a"
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                height: {
                  xs: "200px",
                  sm: "200px",
                  md: "400px",
                  lg: "500px",
                },
                width: "100%",
              }}
            >
              <img
                src={item?.image}
                alt={`Banner ${item.id}`}
                style={{
                  height: "100%",
                  width: "100%",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              />
            </Box>
          ))}
        </Slider>
      </Box>
    </div>
  );
};

export default Header;
